import { z } from "zod";
import { WineColorEnum } from "@/constants/enums/wineColor.enum";
import { i18nMessage } from "@/lib/i18nMessage";

export const WinePreferenceSchema = z.object({
  wineName: z.string().min(1, i18nMessage("shared:forms.winePreference.wineNameRequired")).max(100),
  year: z
    .number({ coerce: true, message: i18nMessage("shared:forms.winePreference.yearRequired") })
    .min(1000, i18nMessage("shared:forms.winePreference.yearInvalid"))
    .max(9999, i18nMessage("shared:forms.winePreference.yearInvalid")),
  alcoholPercent: z
    .number({
      message: i18nMessage("shared:forms.winePreference.alcoholRateRequired"),
      coerce: true,
    })
    .min(1, i18nMessage("shared:forms.winePreference.alcoholPercentRequired"))
    .max(100, i18nMessage("shared:forms.winePreference.alcoholPercentMax")),
  volume: z
    .number({ message: i18nMessage("shared:forms.winePreference.volumeRequired"), coerce: true })
    .gt(0, i18nMessage("shared:forms.winePreference.bottleVolumeRequired")),
  color: z.nativeEnum(WineColorEnum, {
    message: i18nMessage("shared:forms.winePreference.colorRequired"),
  }),
  unitPrice: z
    .number({ message: i18nMessage("shared:forms.winePreference.priceRequired"), coerce: true })
    .min(1, i18nMessage("shared:forms.winePreference.bottlePriceRequired")),
});

export type WinePreferenceData = z.infer<typeof WinePreferenceSchema>;
